import { AdminRole } from '@scg/core/dist/admin/admin-role';

// TODO: Refactor to better data structure
export const getEntityPolicyMap = (role) => {
  const policyGroups = {
    masterAdmin: role === AdminRole.Admin,
    editorAdmin: role !== AdminRole.Viewer,
  };

  const defaultPolicy = {
    canCreate: policyGroups.editorAdmin,
    canEdit: policyGroups.editorAdmin,
    canBulkupload: policyGroups.editorAdmin,
  };

  const policyMap = {
    default: defaultPolicy,
    admin: {
      ...defaultPolicy,
      canCreate: policyGroups.masterAdmin,
      canEdit: policyGroups.masterAdmin,
      canBulkupload: policyGroups.masterAdmin,
    },
  };

  return policyMap;
};
